import { PropsWithChildren } from 'react';
import { TableTbody } from '@mantine/core';

export const TouringCardTableBody: React.FC<PropsWithChildren> = ({
  children,
}) => {
  return <TableTbody>{children}</TableTbody>;
};
